import styled from "@emotion/styled";
import { FC } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Add } from "@livechat/design-system-icons";
import { Button, DesignToken, Icon, SpacingToken, Text } from "@livechat/design-system-react-components";

import { EmbeddedSectionHeaderTitle } from "components/EmbeddedSectionHeaderTitle";
import { TextHelpCenter } from "constants/help-center";
import { EventPlace, trackEngagement } from "helpers/analytics";
import { AutomationsRoutes } from "routes/automations/constants";
import { selectIsAdmin } from "store/entities/agents";
import { withVar } from "themes/helpers";

export const IframeHeader: FC = () => {
  const isAdmin = useSelector(selectIsAdmin);
  const history = useHistory();

  return (
    <Wrapper>
      <EmbeddedSectionHeaderTitle
        title="Ticket rules"
        description={
          <Text>
            Create rules using available conditions and actions to auto-solve cases. Make all your operations smarter,
            well-timed, and human-free.{" "}
            <Button
              kind="link-inverted"
              href={TextHelpCenter.AUTOMATED_WORKFLOWS}
              rel="noopener noreferrer"
              target="_blank"
            >
              Learn more
            </Button>
          </Text>
        }
      />
      <Button
        kind="high-contrast"
        size="compact"
        disabled={!isAdmin}
        onClick={() => {
          history.push(AutomationsRoutes.AddRule);
          trackEngagement("Workflows: Add workflow clicked", EventPlace.Automations, { place: "text-app-header" });
        }}
        icon={<Icon aria-hidden source={Add} />}
        aria-label="New ticket rule"
      >
        New ticket rule
      </Button>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  box-sizing: border-box;
  flex-shrink: 0;
  max-width: 100%;
  padding-left: ${withVar(SpacingToken.Spacing5)};
  padding-right: ${withVar(SpacingToken.Spacing3)};
  height: 52px;
  border-bottom: 1px solid ${withVar(DesignToken.BorderBasicSecondary)};
  position: sticky;
  top: 0;
  background-color: ${withVar(DesignToken.SurfacePrimaryDefault)};
  z-index: 1;

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${withVar(SpacingToken.Spacing2)};
`;
